"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _config = require("./config");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SignUpMetadataManager = /*#__PURE__*/function () {
  function SignUpMetadataManager(options) {
    (0, _classCallCheck2.default)(this, SignUpMetadataManager);
    (0, _defineProperty2.default)(this, "options", void 0);
    this.options = options;
  }

  (0, _createClass2.default)(SignUpMetadataManager, [{
    key: "getAll",
    value: function getAll() {
      return _objectSpread({}, this.extractCookieValues(_config.PARAMS_COOKIE_NAMES), {}, this.extractCookieValues(_config.PERSISTENT_METADATA_NAMES));
    }
  }, {
    key: "cleanAll",
    value: function cleanAll() {
      var _this = this;

      Object.keys(_config.PARAMS_COOKIE_NAMES).forEach(function (paramName) {
        _jsCookie.default.remove(_config.PARAMS_COOKIE_NAMES[paramName], {
          domain: _this.options.cookiesDomain
        });
      });
    }
  }, {
    key: "save",
    value: function save(data) {
      var _this2 = this;

      Object.keys(data).forEach(function (key) {
        if (key in _config.PERSISTENT_METADATA_NAMES) {
          return;
        }

        _this2.validateParam(key);

        var cookieName = _config.PARAMS_COOKIE_NAMES[key];
        var value = data[key];

        if (key in _config.COOKIES_EXPIRATION) {
          _jsCookie.default.set(cookieName, value, {
            domain: _this2.options.cookiesDomain,
            expires: _config.COOKIES_EXPIRATION[key]
          });
        } else {
          _jsCookie.default.set(cookieName, value, {
            domain: _this2.options.cookiesDomain
          });
        }
      });
    }
  }, {
    key: "validateParam",
    value: function validateParam(param) {
      var allowedParams = Object.keys(_config.PARAMS_COOKIE_NAMES);

      if (allowedParams.indexOf(param) === -1) {
        throw new Error("Invalid metadata param passed. Allowed params: ".concat(allowedParams.join(', ')));
      }
    }
  }, {
    key: "extractCookieValues",
    value: function extractCookieValues(config) {
      return Object.keys(config).reduce(function (data, paramName) {
        var fieldValue = _jsCookie.default.get(config[paramName]); // Don't add metadata field if it's empty


        if (!fieldValue) {
          return data;
        }

        return _objectSpread({}, data, (0, _defineProperty2.default)({}, paramName, fieldValue));
      }, {});
    }
  }]);
  return SignUpMetadataManager;
}();

exports.default = SignUpMetadataManager;
//# sourceMappingURL=signup-metadata.js.map